import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import Navigation from '../Navigation/Navigation'
import BerechtigungUtil from '../../services/BerechtigungUtil'
import GPService from '../Geschaeftspartner/GPService'
import GPDto from '../Geschaeftspartner/GPDto'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/VerticalNavigation/VerticalNavigation.js'
import './GPStammdaten'
import './GPVerbrauchsstaette'
import './GPBenutzer'
import './GPZVV'
import AuthorizationFilter from "../Authorization/AuthorizationFilter";

export default class GPDetail extends WebComponent {

  constructor() {
    super()
    this.gpService = new GPService()
  }

  get translationFile() {
    return './views/GPDetail/i18n.json'
  }

  get subsites() {
    return {
      GPStammdaten: {
        render: () => html`
          <eko-frontend-gp-detail-stammdaten .geschaeftspartner="${this.geschaeftspartner}"></eko-frontend-gp-detail-stammdaten>`
      },
      GPVerbrauchsstaette: {
        render: () => html`
          <eko-frontend-gp-detail-verbrauchsstaette></eko-frontend-gp-detail-verbrauchsstaette>`
      },
      GPBenutzer: {
        render: () => html`
          <eko-frontend-gp-detail-benutzer .geschaeftspartner="${this.geschaeftspartner}"></eko-frontend-gp-detail-benutzer>`
      },
      GPZVV: {
        render: () => html`
          <eko-frontend-gp-detail-zvv></eko-frontend-gp-detail-zvv>`
      }
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    if(getNavigationId() === undefined) {
      navigate({ to: getNavigationHash(), id: new BerechtigungUtil().getActiveProfile().gpExtId })
      return
    }
    Promise.resolve(
      this.gpService.read(getNavigationId())
    ).then(json => {
      this.geschaeftspartner = new GPDto(json)
      this.render()
    }).catch(() => navigate({to: Navigation.ROUTES.gpVerfuegungSetup.url, allow: true}))
  }

  getTemplate() {
    const subsite = this.subsites[getNavigationHash()]
    return html`
      <isceco-title id="page-title" text="${this.geschaeftspartner.name}">
      </isceco-title>
      <div class="detail-flex-box">
        <div class="detail-child-left">
          <isceco-vertical-navigation .items="${this._getNavItems()}">
          </isceco-vertical-navigation>
        </div>
        <div class="detail-child-right">
          ${subsite.render()}
        </div>
      </div>
    `
  }

  _getNavItems = () => {
    const roles = new AuthorizationFilter().roles
    return [
      {
        text: this.i18n.translate('gp.stammdaten.title'),
        icon: 'stream',
        url: `${Navigation.ROUTES.gpStammdaten.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.gpStammdaten.url],
        roles: [roles.BWL, roles.OSTRAL, roles.VNB, roles.GP]
      },
      {
        text: this.i18n.translate('gp.verbrauchsstaette.title'),
        icon: 'industry',
        url: `${Navigation.ROUTES.gpVerbrauchsstaette.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.gpVerbrauchsstaette.url],
        roles: [roles.BWL, roles.OSTRAL, roles.VNB, roles.GP]
      },
      {
        text: this.i18n.translate('gp.benutzer.title'),
        icon: 'user friends',
        url: `${Navigation.ROUTES.gpBenutzer.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.gpBenutzer.url],
        roles: [roles.BWL, roles.OSTRAL, roles.VNB, roles.GP_SUPERUSER]
      },
      {
        text: this.i18n.translate('gp.zvv.title'),
        icon: 'users',
        url: `${Navigation.ROUTES.gpZVV.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.gpZVV.url],
        roles: [roles.BWL, roles.OSTRAL, roles.VNB, roles.GP]
      }
    ].filter(i => i.roles.some(r => r))
  }
}

customElements.define('eko-frontend-gp-detail', GPDetail)
